import { BehaviorSubject } from 'rxjs';

export default class ReportViewerBloc {
  selectedItem$ = new BehaviorSubject(null);
  loading$ = new BehaviorSubject(false);
  error$ = new BehaviorSubject(null);
  caseInfo$ = new BehaviorSubject(null);

  constructor({ casesRepository, resourceRepository, dialogRepository }) {
    this.caseRepository = casesRepository;
    this.resourceRepository = resourceRepository;
    this.dialogRepository = dialogRepository;
  }

  async setSelectedItem(item, token) {
    this.selectedItem$.next(item);
    this.loading$.next(true);
    try {
      const resourceInfo = await this.resourceRepository.getResourceInfo(item.uuid, token);
      this.selectedItem$.next({
        ...item,
        path: resourceInfo.path,
      });
      this.error$.next(null);
    } catch (error) {
      this.error$.next(error.message);
    } finally {
      this.loading$.next(false);
    }
  }

  async getCase(caseId, token = null) {
    const caseInfo = await this.caseRepository.getCase(caseId, token);
    this.caseInfo$.next(caseInfo);
  }

  closeDialog() {
    this.dialogRepository.toggleDialog(false);
  }
}
